import { fetcher } from "@/helpers/fetcher";
import { CodeValue, SearchQuery } from "@/types/common";
import { UserEmailRequest, UserMailReceiveRequest, UserRoleRequest, UserSearchCondition, UsersResponse } from "@/types/user";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import qs from "qs";

export const useRoleCodes = () => {
  return useQuery<CodeValue[]>({
    queryKey: ["role-codes"],
    queryFn: async ({ signal }: { signal: AbortSignal }): Promise<CodeValue[]> =>
      fetcher({ url: "/approver/users/role-codes", signal }),
  });
};

export const useUserSearch = (searchQuery: SearchQuery<UserSearchCondition>) => {
  const queryKey = ["approver-users", qs.stringify(searchQuery)];

  return useQuery<UsersResponse>({
    queryKey,
    queryFn: async ({ signal }): Promise<UsersResponse> =>
      fetcher({ url: "/approver/users", params: searchQuery, signal }),
    placeholderData: (previous) => previous,
  });
};

export const useDepartmentHeadsSearch = (searchQuery: SearchQuery<UserSearchCondition>) => {
  const queryKey = ["approver-department-heads", qs.stringify(searchQuery)];

  return useQuery<UsersResponse>({
    queryKey,
    queryFn: async ({ signal }): Promise<UsersResponse> =>
      fetcher({ url: "/approver/department-heads", params: searchQuery, signal }),
    placeholderData: (previous) => previous,
  });
};

export const useRoleUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, request }: { id: number | null; request: UserRoleRequest }) =>
      fetcher({ url: `/approver/users/${id}/role`, method: "PATCH", data: request }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["approver-users"] });
    },
  });
};

export const useEmailUpdate = () => {
  // const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, request }: { id: number | null; request: UserEmailRequest }) =>
      fetcher({ url: `/approver/users/${id}/email`, method: "PATCH", data: request }),
    onSuccess: () => {
      // queryClient.invalidateQueries({ queryKey: ["approver-users"] });
    },
  });
};

export const useMailReceiveUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, request }: { id: number; request: UserMailReceiveRequest }) =>
      fetcher({ url: `/approver/users/${id}/mail-receive`, method: "PATCH", data: request }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["approver-users"] });
    },
  });
};

export const useUploadHrFile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ file }: { file: File }) => {
      const fd = new FormData();
      fd.append("data-file", file);

      return fetcher({
        url: "/approver/data/parse?type=user-data",
        method: "POST",
        headers: { "Content-Type": "multipart/form-data" },
        // params: { type: "user-data" },
        data: fd,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["approver-users"] });
    },
  });
};
